module.exports = __webpack_public_path__ + "static/media/pricingAction1x.61a9891a.png";